<template>
  <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :pulling-text="$t('message.pullingText')"
  :loosing-text="$t('message.loosingText')" :loading-text="$t('message.Loading')">
    <div style="min-height: calc(100vh - 30px)">
      <img src="@/assets/images/bg.png" class="bgH" />
      <div class="banner">
        <van-swipe :autoplay="3000">
          <van-swipe-item v-for="(image, index) in images" :key="index">
            <img v-lazy="imageUrl+image.ImageUrl" style="height: 17vh;border-radius: 14px;" @click="OpenUrl(image.TargetUrl,index)" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="content-board" v-for="(item,x) in list" :key="x">
        <h1>{{ item.GroupName }}</h1>
        <van-row style="display: flex;flex-wrap: wrap;align-items: stretch">
          <van-col span="6" v-for="(item2,x2) in item.APPApplications" :key="x2">
            <div v-if="!item2.isHide" class="content-board-box" @click="getToken(item2,x2,x)">
              <div class="container" v-if="item2.IsFolder">
                <van-row>
                  <van-col span="12" class="text-C" v-for="(item3,x3) in item2.Apps.filter(x=>x.isHide==undefined).slice(0, 4)" :key="x3">
                    <div style="text-align: center;margin:0 auto;border:0px solid #f00;padding:0 2px;">
                      <img style="width:20px" :src="item3.Icon?imageUrl+item3.Icon:require('@/assets/images/01.png')" />
                    </div>
                  </van-col>
                </van-row>
              </div>
              <!--非文件夹-->
              <div class="container" v-if="!item2.IsFolder">
                <img :src="item2.Icon?imageUrl+item2.Icon:require('@/assets/images/01.png')" />
              </div>
              <p :class="getTowHeight(item.APPApplications) ? 'tow' : ''">{{ language=='zh-cn'?item2.Name:item2.ShortName }}</p>
            </div>
            <div class="mover"  :class="[item2.isOpen ? 'open' : '','Left'+ (x2 + 1)]" v-if="item2.IsFolder">
              <div :class="'sj sj'+ (x2 + 1)"></div>
              <van-row :gutter="11">
                <van-col span="6" class="text-C" v-for="(item3,x3) in item2.Apps" :key="x3">
                  <div v-if="!item3.isHide" class="content-board-box" @click="getToken(item3)">
                    <div class="container bgf" style="border-radius: 50%;">
                      <img style="width:32px" :src="item3.Icon?imageUrl+item3.Icon:require('@/assets/images/01.png')" />
                    </div>
                    <p :class="getTowHeight(item2.Apps) ? 'tow' : ''" style="padding:10px 0;">{{ language=='zh-cn'?item3.Name:item3.ShortName }}</p>
                  </div>
                </van-col>
              </van-row>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
  </van-pull-refresh>

</template>

<script>
import ApiUrls from "@/api/apiUrls";
import axios from "axios";
import eruda from 'eruda';
export default {
  components: {},

  data() {
    return {
      hidden:false,
      imageUrl:ApiUrls.imageUrl,
      images: [],
      list:[],
      isLoading: false,
      language:'zh-cn',
      UserId: localStorage.getItem('UserId'),
    };
  },
  computed: {
  },
  async created() {
    if(process.env.NODE_ENV == 'production'){
      let response = await axios.get(ApiUrls.baseUrl+'/AppConfig/fyuserid.json?Version=2');
      console.log(response,'response');
      let isShowConsole = response.data.filter(x=>x.toLowerCase()==this.UserId).length>0
      if(isShowConsole){
        eruda.init();
      }
    }    
    // alert(this.$browserType()+"===="+process.env.NODE_ENV)
    if (this.$browserType() > 4 && process.env.NODE_ENV === 'production') {
      cs.getUserInfo((result) => {
        console.log(result,"result");
        if (result.state == 1) {
          var data = result.result;
          this.setUserSelectInfo(data.ServerUrl,'','')
          
          this.language=data.Language
          this.setLanguage(data.Language)
          window.localStorage.setItem('token',result.access_token)
          window.localStorage.setItem('UserId',data.Id)
          this.fetchNoticeData()
          this.fetchData()
        }
      });
      return
    }
    this.fetchNoticeData()
    this.fetchData()
  },

  beforeCreate() {

  },
  beforeDestroy() {
  },
  mounted() {
  },
  methods: {
    setUserSelectInfo(serverUrl, serverCode, companyCode){
      if (browser.versions.ios) {
          JKEventHandler.callNativeFunction('setUserSelectInfo', {
              serverUrl: serverUrl,
              serverCode: serverCode,
              companyCode: companyCode
          }, function (result) {
              if (callBack) {
                  callBack(result);
              }
          });
      } else if (browser.versions.android) {
          JSBridge.call('device', 'setUserSelectInfo', {
              serverUrl: serverUrl,
              serverCode: serverCode,
              companyCode: companyCode
          }, function (result) {
              if (callBack) {
                  callBack(result);
              }
          })
      }
    },
    setLanguage(lang){
      if (lang == 'en-us') {
          this.$i18n.locale = 'en-GB';
      } else {
          this.$i18n.locale = 'zh-cn';
      }
      console.log(lang,"实际语言");
      console.log(this.$i18n.locale,"i18n语言");
    },
    onRefresh(){
      this.fetchData()
    },
    getTowHeight(arr = []){
      let list = arr.filter(e=>{
        return e.isHide? false : e.Name.length>5
      })
      return list.length > 0 ? true : false
    },
    getQueryVariable(url,name) {
      var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) {
        return unescape(RegExp.$2.replace(/\+/g, " "));
      }else{
        return "";
      }
    },
    OpenUrl(url,idx){
      if(idx==0){
        this.$router.push(url)
      }else{
        this.$OpenUrl(url)
      }
    },
    openCloseMover(index,fIndex){
      let list = JSON.parse(JSON.stringify(this.list))
      list = list.map((e,i)=>{
        e.APPApplications = e.APPApplications.map((a,ai)=>{
          if (i == fIndex && index == ai){
            a.isOpen = !a.isOpen ? true : false
          }else {
            a.isOpen = false
          }
          return a
        })
        return e
      })
      console.log('this.list',list)
      this.list = list
    },
    getToken(row,index,fIndex){
      console.log(row)
      if (row.isHide) return
      if (row.IsFolder) return this.openCloseMover(index,fIndex);
      if (!row.TodoUrl){
        cs.openWebView(row.SystemUrl, true, true, row.IsShowCloseBtn || false);
        return
      }
    },    
    fetchNoticeData(){
      this.$reqPost(ApiUrls.APPMANAGE_GETAPPNOTICEBOARDLIST, {
        UserId:localStorage.getItem('UserId'),
      }).then(res => {
        this.images=res
      })
    },
    fetchData(){
      let toast1 = this.$toast.loading({message: '', forbidClick: true, duration: 0});
      this.$reqPost(ApiUrls.APPMANAGE_GETWORKSPACE, {UserId:localStorage.getItem('UserId'),}).then(res => {
        toast1.close()
        this.list = res.map(e=>{
          if (e.APPApplications.length % 4 > 0){
            for (let i = 0; i < e.APPApplications.length % 4; i++) {
              e.APPApplications.push({isHide: true})
            }
          }
          e.APPApplications = e.APPApplications.map(s=>{

            if (!s.isHide && s.Apps && s.Apps.length > 0){
              if (s.Apps.length % 4 > 0){
                for (let i = 0; i < s.Apps.length % 4; i++) {
                  s.Apps.push({isHide: true})
                }
              }
            }
            return s
          })
          return e
        })
        console.log(this.list,'this.list////////////')
        this.isLoading = false
      }).catch(()=>{
        this.isLoading = false
      })
    }

  },
};
</script>

<style  scoped>
.bgH{
  width: 100%;
  height: auto;
  position: fixed;
  left: 0;
  top: 0;
  z-index: -1;
}
.banner{margin:3vw 3vw 0 3vw;border-radius: 14px;}
.content-board{margin:3vw 11px 10px 11px;background:#fff;border-radius: 14px;padding:1vw 0 0vw 0;box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);}
/* .content-board{margin:3vw 11px 10px 11px;background:#fff;border-radius: 14px;padding:1vw 11px 0vw 11px;box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);} */
.content-board h1{color:#adadae;padding:0 18px;line-height: 30px;font-size: 13px;margin-bottom: 1vw}
.content-board img{width:40px;}
.container {
    background:#dde4ec;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;    /* 垂直居中 */
    width:44px;
    min-width:44px;height: 44px;border-radius: 8px;
    margin-bottom: 11px;margin: 0 auto;
}
.content-board p{
 line-height: 1.5em; /* 每行的高度 */
 overflow: hidden; /* 隐藏溢出的内容 */
 text-align: left;text-align: center;padding:10px 0 20px 0;
 font-size: 12px;
}
.content-board .tow{
  /* height: 3em; */
}
.content-board-box{text-align: center;}
/* .content-board-box{padding:8px 8px 12px;border-radius: 8px;box-sizing:border-box;box-shadow: 0px 0px 5px rgba(0, 0, 0, .1);background: #f9fbff} */
.mover{
  width: calc(94vw - 16px);
  height: 0px;
  background: #ffffff;
  padding: 0 8px;
  box-sizing: border-box;
  border-radius: 12px;
  transition: all 0.1s;
  overflow:hidden;
}
.open{
  margin:0 8px 8px 8px;
  background: #edf1f4;
  padding: 11px 0 0 0px;
  height: auto;
  position: relative;
  overflow:visible;
}
.sj{
  opacity: 0;
  position: absolute;
  top: -12px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 12px solid #edf1f4; /* 底部边框颜色 */
}
.open .sj{
  opacity: 1;
}
.sj1{
  left: calc(13% - 20px);
}
.sj2{
  left: calc(38% - 17px);
}
.sj3{
  left: calc(66% - 20px);
}
.sj4{
  left: calc(92% - 20px);
}
.Left2{
  left: calc(-100% - 0px);
}
.Left3{
  left: calc(-200% - 0px);
}
.Left4{
  left: calc(-300% - 0px);
}
.bgf{
  background: #ffffff;
}
.bgf p{padding:10px!important;}

</style>
